import React from "react";
import get from "lodash/get";
import Matrix from "./matrix";
import Maxdiff from "./Maxdiff";
import MartrixSelect from "./MatrixSelect";
import MartrixSingleSelect from "./matrixSingleSelect";
import Checkbox from "./Checkbox";
import DragSelect from "./DragSelect/index";
import DoubleMatrix from "./DoubleMatrix";

function Index(props) {
  console.log(`src\\pages\\matrix\\index.js`);
  const optionForm = +get(props.info, "preferences.childPrefer.optionForm", 0);
  const limit = +get(props.info, "preferences.childPrefer.limit", 0);

  if (limit === 2) {
    return <Maxdiff {...props} />;
  }

  // 0 普通 1 下拉 2 下拉排序 3 复选下拉拖动 4 卡片
  switch (optionForm) {
    case 1:
      return <MartrixSelect {...props} />;
    case 2:
      return <MartrixSingleSelect {...props} />;
    case 3:
      return <DragSelect {...props} />;
    case 8:
      return <DoubleMatrix {...props} />;
    default:
      return <Matrix {...props} />;
  }
}

Index.Checkbox = Checkbox;

export default Index;
